export let slot_games = [
    {
        Type: "PRAGMATIC-PLAY",
        Data: [
            {
                name: "vs40frrainbow",
            },
            {
                name: "vs5hotburn",
            },
            {
                name: "vs5super7",
            },
            {
                name: "vs7monkeys",
            },
            {
                name: "vs10fruity2",
            },
            {
                name: "vs5joker",
            },
            {
                name: "vs5ultrab",
            },
        ],
    },
    {
        Type: "GAMINATOR-NOVOMATIC",
        Data: [
            {
                name: "WaikikiBeachG",
            },
            {
                name: "MarcoPoloDeluxeG",
            },
            {
                name: "JustJewelsDeluxeG",
            },
            {
                name: "JustFruitsDeluxeG",
            },
            {
                name: "JustJewelsG",
            },
            {
                name: "BeetleManiaDeluxeG",
            },
            {
                name: "HotTargetG",
            },
            {
                name: "GryphonsGoldDeluxeG",
            },
            {
                name: "RoaringFortiesDeluxeG",
            },
            {
                name: "PlentyOfFruits20G",
            },
            {
                name: "PlentyOnTwentyDeluxeG",
            },
            {
                name: "TheMingDynastyG",
            },
            {
                name: "EgyptianExperienceDeluxeG",
            },
            {
                name: "ColdSpellDeluxeG",
            },
            {
                name: "SizzlingCrownG",
            },
            {
                name: "FruitsRoyalsDeluxeG",
            },
            {
                name: "TheMagicFluteG",
            },
            {
                name: "SilverFoxDeluxeG",
            },
            {
                name: "PharaohsGoldDeluxeG",
            },
            {
                name: "LuxuryExpressG",
            },
            {
                name: "BeetleManiaG",
            },
            {
                name: "AgeOfHeroesG",
            },
            {
                name: "Jewels4AllDeluxeG",
            },
            {
                name: "Jewels4AllG",
            },
            {
                name: "ThreeeDeluxeG",
            },
            {
                name: "QueenOfHeartsG",
            },
            {
                name: "MoneyGameG",
            },
            {
                name: "UnicornMagicG",
            },
            {
                name: "LuckyLadyCharmG",
            },
            {
                name: "HatTrickG",
            },
            {
                name: "EmperorsChinaG",
            },
            {
                name: "BananaSplashG",
            },
            {
                name: "AlwaysHotClassicG",
            },
            {
                name: "GoldenArkG",
            },
            {
                name: "FaustG",
            },
            {
                name: "LordOfOceanG",
            },
            {
                name: "ShogunG",
            },
            {
                name: "HauteCoutureG",
            },
            {
                name: "SecretOfEgyptG",
            },
            {
                name: "HolmesWatsonG",
            },
            {
                name: "DartagnanDeluxeG",
            },
            {
                name: "ColumbusDeluxeG",
            },
            {
                name: "ColumbusClassicG",
            },
            {
                name: "IllusionistG",
            },
            {
                name: "PlentyOnTwentyHotG",
            },
            {
                name: "SizzlingHot7",
            },
            {
                name: "WingsOfFireG",
            },
            {
                name: "UltraStarG",
            },
            {
                name: "LuckyPinUpsG",
            },
            {
                name: "JustFruitsG",
            },
            {
                name: "AmazonTreasuresG",
            },
            {
                name: "DolphinsPearlDeluxeG",
            },
            {
                name: "LuckyLadyCharmDeluxeG",
            },
            {
                name: "MariellaG",
            },
            {
                name: "ElToroG",
            },
            {
                name: "BuffaloThunderG",
            },
            {
                name: "LionsG",
            },
            {
                name: "DianasRealmG",
            },
            {
                name: "SissiDeluxeG",
            },
            {
                name: "TheMoneyGameDeluxeG",
            },
            {
                name: "JokerFruitsDeluxeG",
            },
            {
                name: "TreasureJewelsDeluxeG",
            },
            {
                name: "TreasureJewelsClassicG",
            },
            {
                name: "BookOfRaDeluxeG",
            },
            {
                name: "TikiIIslandG",
            },
            {
                name: "Sizzling8G",
            },
            {
                name: "SizzlingHotDeluxeG",
            },
            {
                name: "DolphinsPearlClassicG",
            },
            {
                name: "SizzlingHotClassicG",
            },
            {
                name: "BookOfRaClassicG",
            },
        ],
    },
    {
        Type: "GREENTUBE-NOVOMATIC",
        Data: [
            {
                name: "FruitKing",
            },
            {
                name: "DiceKing",
            },
            {
                name: "RisingTreasures",
            },
            {
                name: "AsgardsThunder",
            },
            {
                name: "PrizeOfTheNile",
            },
            {
                name: "PharaohsTomb",
            },
            {
                name: "AncientGoddess",
            },
            {
                name: "EyeOfTheQueen",
            },
            {
                name: "BookofRaMagic",
            },
            {
                name: "MagicWindow",
            },
            {
                name: "HotCherryDeluxe",
            },
            {
                name: "GoldStarFruits",
            },
            {
                name: "ActionJoker",
            },
            {
                name: "LightningWild",
            },
            {
                name: "HoffMeister",
            },
            {
                name: "FlamencoRoses",
            },
            {
                name: "IndianSpiritDeluxe",
            },
            {
                name: "Super5",
            },
            {
                name: "JumpingJokers",
            },
            {
                name: "BookOfRaDeluxe",
            },
            {
                name: "LuckyLadysCharmDeluxe",
            },
            {
                name: "Faust",
            },
            {
                name: "DolphinsPearlDeluxe",
            },
            {
                name: "ColumbusDeluxe",
            },
            {
                name: "Cindereela",
            },
            {
                name: "BeetlemaniaDeluxe",
            },
            {
                name: "BookOfRaClassic",
            },
            {
                name: "SizzlingHotDeluxe",
            },
            {
                name: "QueenOfHeartsDeluxe",
            },
            {
                name: "FruitSensation",
            },
            {
                name: "RoaringForties",
            },
            {
                name: "LordOfTheOcean",
            },
            {
                name: "MegaJoker",
            },
            {
                name: "PlentyOnTwenty",
            },
            {
                name: "GryphonsGoldDeluxe",
            },
            {
                name: "RedLady",
            },
            {
                name: "GoldenArk",
            },
            {
                name: "GoldenCobrasDeluxe",
            },
            {
                name: "DolphinsPearlClassic",
            },
            {
                name: "SupraHot",
            },
            {
                name: "Chicago",
            },
            {
                name: "SizzlingGems",
            },
            {
                name: "UltraHotDeluxe",
            },
            {
                name: "Xtrahot",
            },
            {
                name: "RedHot40",
            },
            {
                name: "JustJewelsDeluxe",
            },
            {
                name: "Rex",
            },
            {
                name: "Orca",
            },
            {
                name: "Gorilla",
            },
            {
                name: "AsianDiamonds",
            },
            {
                name: "CostaDelCash",
            },
            {
                name: "MysteryStar",
            },
            {
                name: "MysticSecrets",
            },
            {
                name: "IndianSpirit",
            },
            {
                name: "Katana",
            },
            {
                name: "FlameDancer",
            },
            {
                name: "Fruitilicious",
            },
            {
                name: "TotallyWild",
            },
            {
                name: "BookOfFate",
            },
            {
                name: "RedHotFruits",
            },
            {
                name: "PlentyOfFruit40",
            },
            {
                name: "RoaringWilds",
            },
            {
                name: "PlentyOnTwentyiiHot",
            },
            {
                name: "PlentyOfFruit20",
            },
            {
                name: "IslandHeat",
            },
            {
                name: "Royallotus",
            },
            {
                name: "DragonWarrior",
            },
            {
                name: "MusicIsland",
            },
            {
                name: "BookOfRaDice",
            },
            {
                name: "AlwaysHotDeluxe",
            },
            {
                name: "GangsterParadise",
            },
            {
                name: "AmazonsDiamonds",
            },
            {
                name: "LuxRoulette",
            },
            {
                name: "50FortuneFruits",
            },
        ],
    },
    {
        Type: "AMATIC",
        Data: [
            {
                name: "BookOfFortune",
            },
            {
                name: "BookOfAztec",
            },
            {
                name: "Billyonaire",
            },
            {
                name: "BigPanda",
            },
            {
                name: "BellsOnFireHot",
            },
            {
                name: "AztecSecret",
            },
            {
                name: "ArisingPhoenix",
            },
            {
                name: "Admiral",
            },
            {
                name: "BellsOnFire",
            },
            {
                name: "HotFruits20",
            },
            {
                name: "GoldenJoker",
            },
            {
                name: "EnchantedCleopatra",
            },
            {
                name: "LuckyJoker20",
            },
            {
                name: "FortuneGirl",
            },
            {
                name: "WildStars",
            },
            {
                name: "GemStar",
            },
            {
                name: "WildDragon",
            },
            {
                name: "LaGranAventura",
            },
            {
                name: "MagicScatter",
            },
            {
                name: "GrandTiger",
            },
            {
                name: "Vampires",
            },
            {
                name: "AllwaysJoker",
            },
            {
                name: "KingsCrown",
            },
            {
                name: "UltraSeven",
            },
            {
                name: "LightningHot",
            },
            {
                name: "HotChoice",
            },
            {
                name: "AllwaysFruits",
            },
            {
                name: "DragonsKingdom",
            },
            {
                name: "HotDiamonds",
            },
            {
                name: "Hot81",
            },
            {
                name: "BillysGame",
            },
            {
                name: "GoldenBook",
            },
            {
                name: "EyeOfRa",
            },
            {
                name: "AllwaysFruits",
            },
            {
                name: "PartyTime",
            },
            {
                name: "BellsOnFireRombo",
            },
            {
                name: "RedChilli",
            },
            {
                name: "DragonsKingdom",
            },
            {
                name: "WolfMoon",
            },
            {
                name: "WildShark",
            },
            {
                name: "WildRespin",
            },
            {
                name: "Wild7",
            },
            {
                name: "TweetyBirds",
            },
            {
                name: "RoyalUnicorn",
            },
            {
                name: "MerryFruits",
            },
            {
                name: "MermaidsGold",
            },
            {
                name: "MagicOwl",
            },
            {
                name: "MagicIdol",
            },
            {
                name: "MagicForest",
            },
            {
                name: "LuckyCoin",
            },
            {
                name: "LadyLuck",
            },
            {
                name: "LadyJoker",
            },
            {
                name: "HotTwenty",
            },
            {
                name: "HotStar",
            },
            {
                name: "HotScatter",
            },
            {
                name: "Hot7",
            },
            {
                name: "FortunasFruits",
            },
            {
                name: "FireAndIce",
            },
            {
                name: "DragonsPearl",
            },
            {
                name: "DiamondsOnFire",
            },
            {
                name: "DiamondMonkey",
            },
            {
                name: "DiamondCats",
            },
            {
                name: "CoolDiamondsII",
            },
            {
                name: "Casinova",
            },
            {
                name: "Casanova",
            },
        ],
    },
    {
        Type: "APEX",
        Data: [
            {
                name: "LegendOfTheSphinx",
            },
            {
                name: "SphinxMysteries",
            },
            {
                name: "OceanTale",
            },
            {
                name: "RedHotFruits2",
            },
            {
                name: "BankRaid",
            },
            {
                name: "ArrivaArriva",
            },
            {
                name: "EyeOfTheDragon",
            },
            {
                name: "LeonardosCode",
            },
            {
                name: "BarsAndSevens",
            },
            {
                name: "CashRunner",
            },
            {
                name: "RedHotBurning",
            },
            {
                name: "Wizard",
            },
            {
                name: "QueenCleopatra",
            },
            {
                name: "RedHot20",
            },
        ],
    },
    {
        Type: "KAJOT",
        Data: [
            {
                name: "HalloweenKingGo",
            },
            {
                name: "LuckyDragonGo",
            },
            {
                name: "CrazyFruitsGo",
            },
            {
                name: "JokerDreamGo",
            },
            {
                name: "MultiDiamonds81",
            },
            {
                name: "NeonFruits",
            },
            {
                name: "MultiVegas81",
            },
            {
                name: "9Stars",
            },
            {
                name: "9StarsDice",
            },
            {
                name: "DiceVegas81",
            },
            {
                name: "JokerStrong",
            },
            {
                name: "JokerStrongDice",
            },
            {
                name: "KajotSevens",
            },
            {
                name: "Joker81",
            },
            {
                name: "UltimateCristals",
            },
            {
                name: "Turbo27",
            },
            {
                name: "StarsDice",
            },
            {
                name: "Joker81Dice",
            },
            {
                name: "Turbo27Dice",
            },
            {
                name: "MagicLadyGo",
            },
            {
                name: "RingOfFireGo",
            },
            {
                name: "KajotLinesGo",
            },
            {
                name: "RetroWheels",
            },
            {
                name: "DemonMasterGo",
            },
            {
                name: "Vegas27Go",
            },
            {
                name: "TripleStarsGo",
            },
            {
                name: "SimplyTheBest27Go",
            },
            {
                name: "MultiSevenGo",
            },
            {
                name: "Dynamite27Go",
            },
            {
                name: "JokerPlusIIGo",
            },
            {
                name: "HotFactorGo",
            },
            {
                name: "GemStoneGo",
            },
        ],
    },
    {
        Type: "MERKUR",
        Data: [
            {
                name: "CashFruits",
            },
            {
                name: "DoubleTripleChance",
            },
            {
                name: "TropicalHeat",
            },
            {
                name: "ShipOfDreams",
            },
            {
                name: "AgeOfDiscovery",
            },
            {
                name: "GoldBeaver",
            },
            {
                name: "MerkurMagnus7",
            },
            {
                name: "Fruitopia",
            },
            {
                name: "Ultra7Wild",
            },
            {
                name: "CandyFruits",
            },
            {
                name: "WildSupreme",
            },
            {
                name: "Fruitinator",
            },
            {
                name: "SuperLiner",
            },
            {
                name: "BrilliantSparkle",
            },
            {
                name: "Xtra10Liner",
            },
            {
                name: "Super7reels",
            },
            {
                name: "LibertyBells",
            },
            {
                name: "GoldCup",
            },
            {
                name: "BlazingStar",
            },
            {
                name: "ExtraWild",
            },
            {
                name: "MysticalPride",
            },
            {
                name: "GoldOfPersia",
            },
            {
                name: "RailRoad",
            },
            {
                name: "KnightsLife",
            },
            {
                name: "MagicMirror",
            },
        ],
    },
    {
        Type: "EGT",
        Data: [
            {
                id: 801,
                name: "BurningHot",
            },
            {
                id: 802,
                name: "UltimateHot",
            },
            {
                id: 803,
                name: "20SuperHot",
            },
            {
                id: 804,
                name: "40SuperHot",
            },
            {
                id: 805,
                name: "FlamingHot",
            },
            {
                id: 806,
                name: "RiseOfRa",
            },
            {
                id: 807,
                name: "ZodiacWheels",
            },
            {
                id: 809,
                name: "RoyalSecrets",
            },
            {
                id: 810,
                name: "5DazlingHot",
            },
            {
                id: 812,
                name: "AgeOfTroy",
            },
            {
                id: 817,
                name: "GreatCleopatra",
            },
            {
                id: 818,
                name: "VersailesGold",
            },
            {
                id: 819,
                name: "OlypmusGlory",
            },
            {
                id: 823,
                name: "GamesOfLuck",
            },
            {
                id: 824,
                name: "DiceAndRoll",
            },
            {
                id: 825,
                name: "EgyptSky",
            },
            {
                id: 826,
                name: "BookOfMagic",
            },
            {
                id: 830,
                name: "MajesticForest",
            },
            {
                id: 833,
                name: "Hallowen",
            },
            {
                id: 846,
                name: "KashmirGold",
            },
            {
                id: 849,
                name: "LuckyHot",
            },
            {
                id: 854,
                name: "20Diamonds",
            },
            {
                id: 855,
                name: "SummerBliss",
            },
            {
                id: 859,
                name: "AmazonBattle",
            },
            {
                id: 863,
                name: "TheWhiteWoolf",
            },
            {
                id: 865,
                name: "IncasGoldII",
            },
            {
                id: 868,
                name: "LuckAndWild",
            },
            {
                id: 869,
                name: "MoreLuckAndWild",
            },
            {
                id: 875,
                name: "MoreDiceAndRoll",
            },
            {
                id: 889,
                name: "RetroStyle",
            },
            {
                id: 502,
                name: "Magelan",
            },
            {
                id: 511,
                name: "AztecGlory",
            },
            {
                id: 512,
                name: "QueenOfRio",
            },
            {
                id: 528,
                name: "30FruitSpice",
            },
            {
                id: 533,
                name: "10BurningHeart",
            },
            {
                id: 544,
                name: "20DazzlingHot",
            },
            {
                id: 546,
                name: "40LuckyKing",
            },
            {
                id: 547,
                name: "40MegaClover",
            },
            {
                id: 566,
                name: "40BurningHot6  ",
            },
            {
                id: 565,
                name: "BurningHot6",
            },
            {
                id: 578,
                name: "TheEmperorPalace",
            },
            {
                id: 858,
                name: "DarkQueen",
            },
        ],
    },
    {
        Type: "CTGAMING",
        Data: [
            {
                name: "FruitFeast",
            },
            {
                name: "LordOfLuck",
            },
            {
                name: "GoldenAcorn",
            },
            {
                name: "HitTheHot",
            },
            {
                name: "30Treasures",
            },
            {
                name: "40MegaSlot",
            },
            {
                name: "40_Diamond_Treasures",
            },
            {
                name: "HotFruits100",
            },
            {
                name: "40ShiningCoins",
            },
            {
                name: "40Roosters",
            },
            {
                name: "PurpleFruits",
            },
            {
                name: "50_Treasures",
            },
            {
                name: "FortunePyramid",
            },
            {
                name: "CloverParty",
            },
            {
                name: "FullOfTreasures",
            },
            {
                name: "Hot7sX2",
            },
            {
                name: "DoubleHotHabanero",
            },
            {
                name: "PotOfJewels",
            },
            {
                name: "EggAndRooster",
            },
            {
                name: "CelestialRuler",
            },
            {
                name: "ColibriWild",
            },
            {
                name: "FireDozen",
            },
            {
                name: "DancingBananas",
            },
            {
                name: "SmileyXWild",
            },
            {
                name: "50_shining_jewels",
            },
            {
                name: "PurpleHot2",
            },
            {
                name: "GoldenAmulet",
            },
            {
                name: "WildClover",
            },
            {
                name: "FusionFruitBeat",
            },
            {
                name: "BananaParty",
            },
            {
                name: "MightyKraken",
            },
            {
                name: "BigJoker",
            },
            {
                name: "FortuneFish",
            },
            {
                name: "FruitsOfDesire",
            },
            {
                name: "HellsSevens",
            },
            {
                name: "GoldenFlower",
            },
            {
                name: "ShiningTreasures",
            },
            {
                name: "40ShiningJewels",
            },
            {
                name: "WetAndJuicy",
            },
            {
                name: "40Tresaures",
            },
            {
                name: "PotOfLuck",
            },
            {
                name: "JaguarWarrior",
            },
            {
                name: "DancingDragons",
            },
        ],
    },
    {
        Type: "GAMOMAT",
        Data: [
            {
                name: "BooksBulls",
            },
            {
                name: "CrystalBall",
            },
            {
                name: "RomeoJulia",
            },
            {
                name: "FancyFruits",
            },
            {
                name: "AncientRiches",
            },
            {
                name: "PharaosRiches",
            },
            {
                name: "Explodiac",
            },
            {
                name: "Expandable",
            },
            {
                name: "WildRubies",
            },
            {
                name: "BookOfAges",
            },
            {
                name: "RoyalSevenXxl",
            },
            {
                name: "AncientMagic",
            },
            {
                name: "ForeverDiamonds",
            },
            {
                name: "MightyKing",
            },
            {
                name: "LoveIsland",
            },
            {
                name: "MaaaxDiamonds",
            },
            {
                name: "WildsGoneWild",
            },
            {
                name: "GatesPersia",
            },
            {
                name: "SavannaMoon",
            },
            {
                name: "KIngJungle",
            },
            {
                name: "GlamorousTimes",
            },
            {
                name: "KingQueen",
            },
            {
                name: "PhantomsMirror",
            },
            {
                name: "TowerOfPower",
            },
            {
                name: "Fourtyfinestxxl",
            },
        ],
    },
    {
        Type: "PLAYSON",
        Data: [
            {
                name: "book_of_gold_multichance",
            },
            {
                name: "sevens_n_fruits",
            },
            {
                name: "imperial_fruits_5",
            },
            {
                name: "fruits_and_clovers_20",
            },
            {
                name: "sevens_n_fruits_20",
            },
            {
                name: "fruits_and_jokers_20",
            },
            {
                name: "joker_expand",
            },
        ],
    },
    {
        Type: "HPG",
        Data: [
            {
                name: "red_hot",
            },
            {
                name: "super_fruit",
            },
            {
                name: "lucky_40",
            },
            {
                name: "keno_hot_spot",
            },
            {
                name: "keno_3_ball_desktop",
            },
            {
                name: "keno_2_ball_desktop",
            },
            {
                name: "keno_multi_progressive_desktop",
            },
            {
                name: "keno_king_desktop",
            },
        ],
    },
    {
        Type: "NEW",
        Data: [
            {
                name: "FourLuckyClover ----BGAMING",
            },
            {
                name: "MoonSisters     ----BOOONGO",
            },
            {
                name: "PlentyDragons",
            },
            {
                name: "Oktoberfest",
            },
            {
                name: "FruitFeast",
            },
            {
                name: "BookofRaMagic",
            },
            {
                name: "MagicWindow",
            },
            {
                name: "HotCherryDeluxe",
            },
            {
                name: "LordOfTheOceanMagic",
            },
            {
                name: "GoldStarFruits",
            },
            {
                name: "ActionJoker",
            },
            {
                name: "Beerparty",
            },
            {
                name: "Fruitlove",
            },
            {
                name: "40MegaCloverEGT",
            },
            {
                name: "40LuckyKingEGT",
                id: 546,
            },
            {
                name: "FourLuckyClover",
            },
            {
                name: "FruitMillion",
            },
            {
                name: "FourLuckyDiamonds",
            },
        ],
    },
    {
        Type: "TABLE",
        Data: [
            {
                name: "LuxRoulette",
            },
            {
                name: "keno_hot_spot",
            },
            {
                name: "keno_3_ball_desktop",
            },
            {
                name: "keno_2_ball_desktop",
            },
            {
                name: "keno_multi_progressive_desktop",
            },
            {
                name: "keno_king_desktop",
            },
        ],
    },
    {
        Type: "WORLDMATCH",
        Data: [
            {
                name: "JustHot",
            },
            {
                name: "SlotCup",
            },
            {
                name: "BananaKing",
            },
            {
                name: "ChinaLong",
            },
            {
                name: "MrMoneyMaker",
            },
            {
                name: "CasanovasRomance",
            },
            {
                name: "3DFarm",
            },
            {
                name: "UgaAge",
            },
            {
                name: "CircusEvolution",
            },
            {
                name: "VikingLegend",
            },
            {
                name: "BookOfPharaon",
            },
            {
                name: "FruitsEvolution",
            },
            {
                name: "FruitsDimension",
            },
            {
                name: "KingTutsChamber",
            },
            {
                name: "Aquarium",
            },
            {
                name: "DiamondCroupier",
            },
            {
                name: "PolarAdventure",
            },
            {
                name: "ThePinguizz",
            },
            {
                name: "ArenaDeToros",
            },
            {
                name: "DragonsReels",
            },
            {
                name: "Hollywood",
            },
            {
                name: "SlotCup",
            },
            {
                name: "BananaKing",
            },
        ],
    },
    {
        Type: "WAZDAN",
        Data: [
            {
                name: "VegasHot",
            },
            {
                name: "Sizzling777",
            },
            {
                name: "MagicFruits4Dlx",
            },
            {
                name: "BlackHorse",
            },
            {
                name: "Hot777",
            },
            {
                name: "WildJack81",
            },
            {
                name: "BookOfMagicDlx",
            },
            {
                name: "HighwayToHell",
            },
            {
                name: "MagicOfTheRing",
            },
            {
                name: "MagicTargetDlx",
            },
            {
                name: "BurningReels",
            },
            {
                name: "MagicStars",
            },
            {
                name: "FenixPlayDlx",
            },
            {
                name: "CorridaRomance",
            },
            {
                name: "ColinTheCat",
            },
            {
                name: "MagicHot4Dlx",
            },
            {
                name: "DraculasCastle",
            },
            {
                name: "MagicHot4",
            },
            {
                name: "MagicFruits4",
            },
            {
                name: "MagicFruitsDlx",
            },
            {
                name: "FenixPlay",
            },
            {
                name: "Magic3Stars",
            },
            {
                name: "BackToThe70",
            },
            {
                name: "BurningStars",
            },
            {
                name: "HungryShark",
            },
            {
                name: "GoodLuck40",
            },
            {
                name: "CaptainShark",
            },
            {
                name: "GoldenSphinx",
            },
            {
                name: "NightClub81",
            },
            {
                name: "HighwayToHell",
            },
            {
                name: "MagicFruits81",
            },
        ],
    },
    {
        Type: "PLAYNGO",
        Data: [
            {
                name: "BookOfDead",
            },
        ],
    },
    {
        Type: "NETENT",
        Data: [
            {
                name: "Starburst",
            },
            {
                name: "Dracula",
            },
            {
                name: "JokerPro",
            },
            {
                name: "MagicPortals",
            },
            {
                name: "Victorious",
            },
            {
                name: "Spellcast",
            },
            {
                name: "DazleMe",
            },
            {
                name: "TwinHappiness",
            },
            {
                name: "TwinSpin",
            },
            {
                name: "GhostPirates",
            },
        ],
    },
    {
        Type: "SYNOT",
        Data: [
            {
                name: "JokersFive",
            },
            {
                name: "FruityGold",
            },
            {
                name: "DoubleHot",
            },
            {
                name: "WildBlooms",
            },
            {
                name: "TheWildJob",
            },
            {
                name: "AladdinAndTheGoldenPalace",
            },
            {
                name: "WildWarp",
            },
            {
                name: "FruitAwards",
            },
            {
                name: "BookOfSecretsSix",
            },
            {
                name: "BookOfSecrets",
            },
            {
                name: "GoldenMyth",
            },
            {
                name: "LuckyPot",
            },
            {
                name: "EightyEightPearls",
            },
            {
                name: "AmazonsWonders",
            },
            {
                name: "Joker50Deluxe",
            },
            {
                name: "Diamondz",
            },
            {
                name: "FruityGold81",
            },
            {
                name: "FruitsGoMultiply",
            },
            {
                name: "SixFruitsDeluxe",
            },
            {
                name: "MoonlightFortune",
            },
            {
                name: "Joker40",
            },
            {
                name: "HellMania",
            },
            {
                name: "HellFruits",
            },
            {
                name: "FruitsAndFire",
            },
            {
                name: "FruitiXXL",
            },
            {
                name: "FruitiXL",
            },
            {
                name: "FruitiX",
            },
            {
                name: "FruitiXX",
            },
            {
                name: "Fruiti",
            },
            {
                name: "SixFruits",
            },
            {
                name: "HellBars",
            },
        ],
    },
    {
        Type: "BGAMING",
        Data: [
            {
                name: "FourLuckyClover",
            },
            {
                name: "FruitMillion",
            },
            {
                name: "FourLuckyDiamonds",
            },
            {
                name: "FruitMillionOct",
            },
            {
                name: "DragonsGold100",
            },
            {
                name: "MissCherryFruits",
            },
        ],
    },
    {
        Type: "INBET",
        Data: [
            {
                name: "ShiningFruits",
            },
            {
                name: "DiamondDash",
            },
            {
                name: "BlazingFruits",
            },
            {
                name: "GrandCrown",
            },
            {
                name: "GrandRiches",
            },
            {
                name: "ExtremelyRich",
            },
            {
                name: "SizlingStar",
            },
            {
                name: "MagnifieendFruits",
            },
            {
                name: "RoastingHot100",
            },
            {
                name: "ExtraClover",
            },
            {
                name: "InfinitelyHot",
            },
            {
                name: "WorldOfFruit",
            },
            {
                name: "FruitFashion",
            },
            {
                name: "RedHotSeven",
            },
            {
                name: "FruitAndWild",
            },
            {
                name: "FruitsFortuneWheel",
            },
            {
                name: "RoastingHot40",
            },
            {
                name: "MajestyFruits",
            },
            {
                name: "KinglyCrown",
            },
            {
                name: "FruitSolar",
            },
            {
                name: "RoastingHot",
            },
            {
                name: "Fruittastic",
            },
            {
                name: "FruitYard",
            },
            {
                name: "FruitScapes",
            },
            {
                name: "EpicHot",
            },
            {
                name: "FruitBang",
            },
            {
                name: "HotFruitsWheel",
            },
            {
                name: "Dazling7",
            },
            {
                name: "FiringHot",
            },
            {
                name: "MerryClover",
            },
            {
                name: "Fruitomatic",
            },
        ],
    },
];
